const hn = window.location.hostname
var isTest = true;
var apiPath = '';
var oldDomain = '';
var mapApi = '';
var testsystemId = '';
switch(hn) {
  case 'admin.book.world':
  case 'admin-m.book.world':
  case 'admin-s.book.world':
    isTest = false;
    apiPath = 'https://'+hn.replace('admin', 'restapi')+'/'; 
    oldDomain = 'https://wrap.bookdotworld.com'
    //oldDomain = 'https://'+window.location.hostname.replace('admin', 'wrap').replace('.book.world', '.alixon.ch');
    mapApi = 'AIzaSyB1ICp-UDdEOrse9BNI1nnoQpgFEzrx-28' // google Konto info@dormproject.ch
    break;
  
  case 'localhost':
    const systno = window.location.port - 3000;
    apiPath = 'https://restapi.dev'+systno+'.book.world/';
    oldDomain = 'https://dormdev'+systno+'.alixon.ch'
    mapApi = 'AIzaSyAqxA-cpTjwJkNIqxEQzFTL5AI5XZ-5L5U'
    // https://console.cloud.google.com/google/maps-apis/credentials?project=lateral-isotope-457014-k2
    mapApi = 'AIzaSyB1ICp-UDdEOrse9BNI1nnoQpgFEzrx-28' // google Konto info@dormproject.ch
    testsystemId = 'dev'+systno
    break;
  
  default:    // admin.dev1.book.world
    apiPath = 'https://'+hn.replace('admin.', 'restapi.')+'/'; 
    oldDomain = 'https://'+hn.replace('admin.', 'dorm').replace('.book.world', '.alixon.ch');  //dormdev1.alixon.ch
    mapApi = 'AIzaSyB1ICp-UDdEOrse9BNI1nnoQpgFEzrx-28' // google Konto info@dormproject.ch
    testsystemId = hn.split('.')[1];
  break;
  
}

export { apiPath, oldDomain, mapApi, testsystemId };

export default isTest;
